import { Benefit, BenefitKeyPath } from '../../@types/benefits';
import { OpportunityCheck } from '../content/benefits/modals/opportunityCheck/OpportunityCheck';
import { ExclusiveListings } from '../content/benefits/modals/exclusiveListings/ExclusiveListings';
import { FirstInInbox } from '../content/benefits/modals/firstInInbox/FirstInInbox';
import { SchufaCheck } from '../content/benefits/modals/schufaCheck/SchufaCheck';
import { ApplicationPackage } from '../content/benefits/modals/applicationPackage/ApplicationPackage';
import { Valuation } from '../content/benefits/modals/valuation/Valuation';
import { RealEstateProof } from '../content/benefits/modals/realEstateProof/RealEstateProof';
import { RealEstateDamageReport } from '../content/benefits/modals/realEstateDamageReport/RealEstateDamageReport';
import { LegalInsurance } from '../content/benefits/modals/legalInsurance/LegalInsurance';
import { BenefitModalProps } from '../../@types/benefitModalProps';
import {
  CHANCEN_CHECK,
  EXKLUSIVE_ANZEIGEN,
  OBEN_IM_POSTFACH,
  SCHUFA,
  VORSTELLUNGSMAPPE,
  IMMOBILIENBEWERTUNG,
  DERKA_IMMOBILIENBEWERTUNG,
  DEKRA_BAUSCHADENGUTACHTEN,
  NACHBARSCHAFTS,
  MIETERSCHUTZ,
  MIETKAUTIONSBURGSCHAFT,
  SCHLUSSELDIENST,
  NEBENKOSTEN_CHECK,
  MIETRECHTSBERATUNG,
  UMZUGSKISTEN,
  LAGERRAUM,
  BEWERBERMAPPE,
  UMZUGSSERVICE,
  RECHTSBERATUNG,
  SCHLUESSELDIENST,
  MIETRECHTSSCHUTZ,
  MEDIATION,
  ADRESSWECHSEL,
  MAGENTA_TV,
} from '../../domain/routes';
import { Mieterschutz } from '../content/benefits/modals/mieterschutz/Mieterschutz';
import { Lagerraum } from '../content/benefits/modals/lagerraum/Lagerraum';
import { RelocationBox } from '../content/benefits/modals/relocationBox/RelocationBox';
import { Mietrechtsberatung } from '../content/benefits/modals/mietrechtsberatung/Mietrechtsberatung';
import { Mietkautionsburgschaft } from '../content/benefits/modals/Mietkautionsburgschaft/Mietkautionsburgschaft';
import { ApplicationPackageMieterPlus } from '../content/benefits/modals/applicationPackageMieterPlus/ApplicationPackageMieterPlus';
import { RelocationService } from '../content/benefits/modals/relocationService/RelocationService';
import { OpportunityCheckMieterPlus } from '../content/benefits/modals/opportunityCheckMieterPlus/OpportunityCheckMieterPlus';
import { SchufaCheckMieterPlus } from '../content/benefits/modals/schufaCheckMieterPlus/SchufaCheckMieterPlus';
import { ExclusiveListingsMieterPlus } from '../content/benefits/modals/exclusiveListingsMieterPlus/ExclusiveListingsMieterPlus';
import { FirstInInboxMieterPlus } from '../content/benefits/modals/firstInInboxMieterPlus/FirstInInboxMieterPlus';
import { BillCheckV3 } from '../content/benefits/modals/billCheckV3/BillCheckV3';
import { Mediation } from '../content/benefits/modals/mediation/Mediation';
import { Mietrechtsschutz } from '../content/benefits/modals/mietrechtsschutz/Mietrechtsschutz';
import { Rechtsberatung } from '../content/benefits/modals/rechtsberatung/Rechtsberatung';
import { Schlüsselnotdienst } from '../content/benefits/modals/schlüsselnotdienst/Schlüsselnotdienst';
import { Schluesseldienst } from '../content/benefits/modals/schluesseldienst/Schluesseldienst';
import { MagentaTv } from '../content/benefits/modals/magentaTv/MagentaTv';
import { AddressChange } from '@/components/content/benefits/modals/addressChange/AddressChange';

/**
 * @deprecated This type is deprecated and needs to be checked after full modal migration phase.
 * @see MODALS
 * @TODO check if this after modal migration phase
 */
export const KAEUFER_BENEFIT_TO_MODAL = {
  [Benefit.OPPORTUNITY_CHECK]: {
    component: OpportunityCheck,
    path: BenefitKeyPath.OPPORTUNITY_CHECK,
  },
  [Benefit.EXCLUSIVE_LISTINGS]: {
    component: ExclusiveListings,
    path: BenefitKeyPath.EXCLUSIVE_LISTINGS,
  },
  [Benefit.FIRST_IN_INBOX]: {
    component: FirstInInbox,
    path: BenefitKeyPath.FIRST_IN_INBOX,
  },
  [Benefit.SCHUFA_CHECK]: {
    component: SchufaCheck,
    path: BenefitKeyPath.SCHUFA_CHECK,
  },
  [Benefit.APPLICATION_PACKAGE]: {
    component: ApplicationPackage,
    path: BenefitKeyPath.APPLICATION_PACKAGE,
  },
  [Benefit.VALUATION]: {
    component: Valuation,
    path: BenefitKeyPath.VALUATION,
  },
  [Benefit.REAL_ESTATE_PROOF]: {
    component: RealEstateProof,
    path: BenefitKeyPath.REAL_ESTATE_PROOF,
  },
  [Benefit.REAL_ESTATE_DAMAGE_REPORT]: {
    component: RealEstateDamageReport,
    path: BenefitKeyPath.REAL_ESTATE_DAMAGE_REPORT,
  },
  [Benefit.LEGAL_INSURANCE]: {
    component: LegalInsurance,
    path: BenefitKeyPath.LEGAL_INSURANCE,
  },
};

interface Modal {
  [key: string]: React.FC<BenefitModalProps>;
}

interface Modals {
  WOHNENPLUS: Modal;
  MIETERPLUS: Modal;
  KAEUFERPLUS: Modal;
}

export const MODALS: Modals = {
  MIETERPLUS: {
    [CHANCEN_CHECK]: OpportunityCheckMieterPlus,
    [SCHUFA]: SchufaCheckMieterPlus,
    [EXKLUSIVE_ANZEIGEN]: ExclusiveListingsMieterPlus,
    [OBEN_IM_POSTFACH]: FirstInInboxMieterPlus,
    [BEWERBERMAPPE]: ApplicationPackageMieterPlus,
    [UMZUGSSERVICE]: RelocationService,
    [ADRESSWECHSEL]: AddressChange,
    [MAGENTA_TV]: MagentaTv,
  },
  WOHNENPLUS: {
    [MIETERSCHUTZ]: Mieterschutz,
    [MIETKAUTIONSBURGSCHAFT]: Mietkautionsburgschaft,
    [SCHLUSSELDIENST]: Schlüsselnotdienst,
    [NEBENKOSTEN_CHECK]: BillCheckV3,
    [MIETRECHTSBERATUNG]: Mietrechtsberatung,
    [UMZUGSKISTEN]: RelocationBox,
    [LAGERRAUM]: Lagerraum,
    [RECHTSBERATUNG]: Rechtsberatung,
    [SCHLUESSELDIENST]: Schluesseldienst,
    [MIETRECHTSSCHUTZ]: Mietrechtsschutz,
    [MEDIATION]: Mediation,
    [MAGENTA_TV]: MagentaTv,
    [ADRESSWECHSEL]: AddressChange,
  },
  KAEUFERPLUS: {
    [CHANCEN_CHECK]: OpportunityCheck,
    [EXKLUSIVE_ANZEIGEN]: ExclusiveListings,
    [OBEN_IM_POSTFACH]: FirstInInbox,
    [SCHUFA]: SchufaCheck,
    [VORSTELLUNGSMAPPE]: ApplicationPackage,
    [IMMOBILIENBEWERTUNG]: Valuation,
    [DERKA_IMMOBILIENBEWERTUNG]: RealEstateProof,
    [DEKRA_BAUSCHADENGUTACHTEN]: RealEstateDamageReport,
    [NACHBARSCHAFTS]: LegalInsurance,
    [MAGENTA_TV]: MagentaTv,
    [ADRESSWECHSEL]: AddressChange,
  },
};
